import React, { Component } from 'react'
import { times }  from 'lodash'
import moment from 'moment'
import {  Col, FormGroup } from "react-bootstrap";
import {  Field, reduxForm, propTypes,formValueSelector,change } from 'redux-form'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { PropTypes } from 'prop-types'
import { saveLaneConditionsInfo } from "../../../../redux/actions/action_event"
import { blue,videoblue,green,warning,forms,
					lblattrs,lblattrsmed,inputattrs,inputattr3,oilfieldoptions
} from "../../../../utils/constants"
import { renderOptionsField } from '../../../../modules/components/fieldoptioncomponent'
import { renderFormattedField } from '../../../../modules/components/formattedfield'
import fields from '../LaneConditions/fields'

const oillevels = {
   sport: 'sport',
   challenge:'challenge',
   standard:'standard'
}

const FormName = forms.eventinfo

class OilRatio extends Component {
    static propTypes = {
        ...propTypes
    }
    constructor(props) {
			super(props)
			this.showRatios = this.showRatios.bind(this)
			this.showHeader = this.showHeader.bind(this)
			this.oillevel = this.oillevel.bind(this)
			this.renderOilConditionField = this.renderOilConditionField.bind(this)
			this.verifyOilValues = this.verifyOilValues.bind(this)
    } 
    componentDidMount() {
    }
    oillevel(fld, name)
    {
			let level =  oillevels.standard
			const { eventSeasonSettings } = this.props
			let color = green

			if (eventSeasonSettings) {
				const { oilSportTo,oilChallengeFrom,oilChallengeTo } = eventSeasonSettings
				const fldvalue = this.props.oilratio[fld][name]

				if(fldvalue === ''){
					return ''
				}

				if (parseFloat(fldvalue) <= parseFloat(oilSportTo))
				{
					level =  oillevels.sport
					color = warning
				}
				else if((fldvalue >= oilChallengeFrom) && (fldvalue <= oilChallengeTo))
				{
					level = oillevels.challenge
					color = blue
				} 
			}
			return (<label id={'conditiontype'}   style={{ maxWidth:'70px' , color:color,fontWeight:'bold',fontSize:'115%' }}>{level}</label>)   
    }
    verifyOilValues()
    {
			const { dispatch,dailyoilratios,dailyoilratiosmen,dailyoilratioswomen } = this.props
			if(dailyoilratios && dailyoilratiosmen && dailyoilratioswomen ){
				dispatch(change(FormName, 'oilratio.2.men',''))
				dispatch(change(FormName, 'oilratio.2.wommen',''))
				dispatch(change(FormName, 'oilratio.2.single',''))
				dispatch(change(FormName, 'oilratio.3.men',''))
				dispatch(change(FormName, 'oilratio.3.wommen',''))
				dispatch(change(FormName, 'oilratio.3.single',''))
			} 
			if (!dailyoilratiosmen){
				dispatch(change(FormName, 'oilratio.2.men',''))
				dispatch(change(FormName, 'oilratio.3.men',''))
			}
			if (!dailyoilratioswomen){
				dispatch(change(FormName, 'oilratio.2.women',''))
				dispatch(change(FormName, 'oilratio.3.wommen',''))
			}
    }
    renderOilConditionField(fieldname)
    {
      return ( 
				<Field
					name={fieldname}
					component={renderFormattedField}
					placeholder = '#.##'
					inputattrs = {inputattr3}
					options={oilfieldoptions}
					
				/>)
    }  
    showHeader(){
           
			const { gender,eventnumberofdays,dailyoilratios,dailyoilratiosmen,dailyoilratioswomen } = this.props
			const fldname = gender ? fields.DAILYOILRATIOS + gender.toLowerCase() :  fields.DAILYOILRATIOS
			
			// make sure state is correct - Double check statemet below
			//this.verifyOilValues()
			return ( 
				<div>
					{
						(
							(gender !== undefined) &&
							<FormGroup>
								<h4 className={lblattrsmed} style={{ color: videoblue }}>  {gender} Oil Ratio </h4>
							</FormGroup> 
						)  
					}
					{ 
						eventnumberofdays > 1 && 
							(
								<Field
									label='Different oil ratios each day?'
									labelattrs = {lblattrs}
									inputattrs = {inputattrs}
									name={fldname}
									id={fldname}
									values={[
													{ name:'Yes', abbreviation:'true' },
													{ name:'No', abbreviation:'false' },
									]}                                   
									component={renderOptionsField}
									defaultvalue={!gender ? dailyoilratios : ( gender.toLowerCase() == "women" ? dailyoilratioswomen:dailyoilratiosmen)}
							/>) 
					}               
			</div>)
    }
    showRatios() {
      const { eventnumberofdays,  dailyoilratios, dailyoilratioswomen, dailyoilratiosmen } = this.props
      const day = eventnumberofdays
      const gender = this.props.gender ? this.props.gender.toLowerCase() : ''
      let template

      if((day === 0) || (day === 1) || (gender + dailyoilratios === 'false')) 
      {
				const property = gender ? gender:'single'
				const fldname = `oilratio.1.${property}`
				template = (<FormGroup>
					<label className={lblattrs}>Oil ratio</label>
					<Col md={6} lg={6}>
						<FormGroup>
							{this.renderOilConditionField(fldname)}
							{this.oillevel(1,property)}
						</FormGroup>                          
					</Col>
				</FormGroup>)
      } else if (((dailyoilratiosmen == 'false') && (gender == 'men')) || 
                ((dailyoilratioswomen == 'false') && (gender == 'women'))) {
        const property = gender
        const fldname = `oilratio.1.${property}`
        template = (<FormGroup>
					<label className={lblattrs}>Oil ratio</label>
					<Col md={6} lg={6}>
						<FormGroup>
							{this.renderOilConditionField(fldname)}
							{this.oillevel(1,property)}
						</FormGroup>                          
					</Col>
				</FormGroup>)
      }
   
      else
      {
				const _this = this
				template = (times(day, function(i) {
				const currentDay =  i + 1 
				const property = gender ? gender:'single'
				const fldname = `oilratio.${currentDay}.${property}`
				return (
					<FormGroup key={currentDay}>
						<label className={lblattrsmed}>Oil ratio day {currentDay}</label>
						<Col sm={8 } md={6} lg={6} key={currentDay}>
							{_this.renderOilConditionField(fldname)}
							{_this.oillevel(currentDay,property)}
						</Col>
					</FormGroup>
				)
        }))
      }
      return template
    }
    render()
    {
			return (
				<div>
					{ this.showHeader()}
					{ this.showRatios() }
				</div>
			)
    }
}
function validate(values) {
	const errors = {}
	if(!values){
		errors.jvevent = 'Please indicate jv participation'
	}
	return errors
}
OilRatio.propTypes = {
	eventnumberofdays: PropTypes.number,
	dispatch:PropTypes.func,
	dailyoilratios: PropTypes.string,
	dailyoilratioswomen: PropTypes.string,
	dailyoilratiosmen: PropTypes.string,
	oilratio: PropTypes.object,
	oilratiosetting: PropTypes.object,
	isoilratiobygender: PropTypes.string,
	eventgenderwomen: PropTypes.bool,
	eventgendermen: PropTypes.bool,
	gender:PropTypes.string,
	eventSeasonSettings:PropTypes.object
}
function mapStateToProps(state,ownProps){ 
	const formName =  ownProps.form
	const selector = formValueSelector(formName)
	const isoilratiobygender = selector(state,fields.ISOILRATIOBYGENDER)
	const dailyoilratios     = selector(state,fields.DAILYOILRATIOS)
	const dailyoilratioswomen = selector(state,fields.DAILYOILRATIOSWOMEN)
	const dailyoilratiosmen   = selector(state,fields.DAILYOILRATIOSMEN)
	const oilratio           = selector(state,fields.OILRATIO)
	const eventgendermen     = selector(state,'eventgendermen')
	const eventgenderwomen   = selector(state,'eventgenderwomen')
	const startdate          = selector(state,'startdate')
	const enddate            = selector(state,'enddate')
	const eventnumberofdays  = moment(enddate).diff(moment(startdate),'days') + 1
	const eventSeasonSettings = selector(state,'eventSeasonSettings')
    
	return {
		eventnumberofdays,
		isoilratiobygender,
		dailyoilratios,
		dailyoilratioswomen,
		dailyoilratiosmen,
		oilratio,
		// oilratiosetting,
		eventgenderwomen,
		eventgendermen,
		eventSeasonSettings
	}
}  
function mapDispatchToProps(dispatch){
	return bindActionCreators({
		saveLaneConditionsInfo
	},dispatch)
}
export default reduxForm({
	validate,
	form:FormName,
	destroyOnUnmount: false,
	forceUnregisterOnUnmount: false
})(connect(mapStateToProps,mapDispatchToProps)(OilRatio))



// WEBPACK FOOTER //
// ./src/containers/event/EventWizard/OilRatio/index.js